import React from 'react'
import { Box } from 'components/Layout'
import { COLOR_INTENT, FONT_SIZE, FONT_STACK, SPACE } from 'Theme'
import { HoverableLinkWithText } from './HoverableLinkWithText'

interface SectionHeadingProps {
  href: string
  itemProp?: string
}

export const DesktopSectionHeading: React.FC<
  React.PWC<SectionHeadingProps>
> = ({ children, href, itemProp }) => (
  <Box mb={SPACE.PX_16}>
    <HoverableLinkWithText
      color={COLOR_INTENT.MENU.HEADING.DEFAULT}
      fontSize={FONT_SIZE.PX_18}
      fontFamily={FONT_STACK.SERIF}
      href={href}
      itemProp={itemProp}
    >
      {children}
    </HoverableLinkWithText>
  </Box>
)
